import React, { useState } from "react";
import { Avatar, Box, Chip, Typography } from "@mui/material";
import { settings } from "app";
import { studentRequests } from "api/studentApi";
import { BlobImagePreview } from "server/components";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { EducationStatuses } from "utils/constants";
import UpdateStudentAvatarDialog from "./UpdateStudentAvatarDialog";

const getStatusColor = status => {
  switch (status) {
    case EducationStatuses.Active:
      return "success";
    case EducationStatuses.Graduate:
    case EducationStatuses.GraduationProcess:
      return "info";
    default:
      return "error";
  }
};

const InfoRow = ({ label, value }) => (
  <Box sx={{ display: "flex", gap: 1, alignItems: "baseline" }}>
    <Typography
      sx={{ fontSize: "1rem" }}
      color="text.secondary"
    >
      {label}:
    </Typography>
    <Typography sx={{ fontSize: "1.15rem", fontWeight: "bold" }}>{value ?? "-"}</Typography>
  </Box>
);

const StudentAvatar = ({ educationId, studentId, facultyNumber, ean, educationStatus }) => {
  const [reloadToken, setReloadToken] = useState(0);

  const url = educationId ? `${settings.gatewayApi}/${studentRequests.getStudentProfilePicture(educationId)}` : null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mt: 2,
      }}
    >
      <Box sx={{ flex: 1 }} />
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
        <Box sx={{ position: "relative", width: 100, height: 100 }}>
          <BlobImagePreview
            url={url}
            alt="Профилна снимка"
            reloadToken={reloadToken}
            containerSx={{ display: "flex", justifyContent: "center" }}
            imgStyle={{
              border: "2px solid #ddd",
              width: 100,
              height: 100,
              borderRadius: "50%",
              objectFit: "cover",
              objectPosition: "center",
            }}
            fallback={<Avatar sx={{ width: 100, height: 100 }} />}
          />
          <SecuredComponent permission={permissions.canUpdateStudentProfilePicture}>
            <UpdateStudentAvatarDialog
              studentId={studentId}
              onUpdated={() => setReloadToken(token => token + 1)}
            />
          </SecuredComponent>
        </Box>
        {educationStatus && (
          <Chip
            label={educationStatus}
            color={getStatusColor(educationStatus)}
            sx={{ fontWeight: "bold" }}
          />
        )}
      </Box>
      <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 1,
            paddingX: 2,
            paddingY: 1,
          }}
        >
          <InfoRow
            label="Факултетен номер"
            value={facultyNumber}
          />
          <InfoRow
            label="ЕАН номер"
            value={ean}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default StudentAvatar;
